// src/store/index.js
import {createStore} from 'vuex';

import web from "@/store/web";
import user from "@/store/user";

export default createStore({
    modules: {
        // 页面配置
        web,
        // 用户配置
        user
    }
});
